import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';

export default function Navbar() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileOpen, setIsMobileOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 60);
    };
    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    setIsMobileOpen(false);
  }, [location]);

  const navLinks = [
    { label: '首页', href: '/' },
    { label: '分类', href: '/category/rexue' },
    { label: '排行榜', href: '/#popular' },
    { label: '最新更新', href: '/#latest' },
    { label: '关于我们', href: '/about' },
  ];

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled
          ? 'bg-background-50/95 backdrop-blur-md border-b border-background-200/60'
          : 'bg-transparent'
      }`}
    >
      <div className="w-full px-4 md:px-6">
        <div className="flex items-center justify-between h-16">
          <Link to="/" className="flex items-center gap-2.5 flex-shrink-0">
            <div className="w-9 h-9 rounded-lg bg-primary-500 flex items-center justify-center">
              <i className="ri-book-read-line text-lg text-background-50"></i>
            </div>
            <span className="text-lg font-bold text-foreground-900 font-heading whitespace-nowrap">
              韩漫在线
            </span>
          </Link>

          <div className="hidden md:flex items-center gap-1">
            {navLinks.map((link) => {
              const isActive =
                link.href === '/' ? location.pathname === '/' : location.pathname.startsWith(link.href);
              return (
                <Link
                  key={link.href}
                  to={link.href}
                  className={`px-4 py-2 text-sm font-medium rounded-lg transition-all duration-200 whitespace-nowrap cursor-pointer ${
                    isActive
                      ? 'text-primary-600 bg-primary-100/60'
                      : 'text-foreground-700 hover:text-foreground-900 hover:bg-background-200/50'
                  }`}
                >
                  {link.label}
                </Link>
              );
            })}
          </div>

          <div className="hidden md:flex items-center gap-3">
            <button
              className="w-9 h-9 rounded-lg bg-background-100 flex items-center justify-center text-foreground-600 hover:text-foreground-900 hover:bg-background-200 transition-colors cursor-pointer"
              aria-label="搜索"
            >
              <i className="ri-search-line text-base"></i>
            </button>
            <Link
              to="/category/rexue"
              className="px-5 py-2 bg-primary-500 text-background-50 text-sm font-medium rounded-lg hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
            >
              开始阅读
            </Link>
          </div>

          <button
            className="md:hidden w-9 h-9 rounded-lg bg-background-100 flex items-center justify-center cursor-pointer"
            onClick={() => setIsMobileOpen(!isMobileOpen)}
            aria-label="菜单"
          >
            <i className={`text-lg ${isMobileOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
          </button>
        </div>
      </div>

      {isMobileOpen && (
        <div className="md:hidden bg-background-50 border-t border-background-200/60 px-4 py-4">
          <div className="flex flex-col gap-1">
            {navLinks.map((link) => {
              const isActive =
                link.href === '/' ? location.pathname === '/' : location.pathname.startsWith(link.href);
              return (
                <Link
                  key={link.href}
                  to={link.href}
                  className={`px-4 py-3 text-sm font-medium rounded-lg transition-all duration-200 whitespace-nowrap cursor-pointer ${
                    isActive
                      ? 'text-primary-600 bg-primary-100/60'
                      : 'text-foreground-700 hover:text-foreground-900 hover:bg-background-200/50'
                  }`}
                >
                  {link.label}
                </Link>
              );
            })}
            <Link
              to="/category/rexue"
              className="mt-2 px-4 py-3 bg-primary-500 text-background-50 text-sm font-medium rounded-lg text-center hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
            >
              开始阅读
            </Link>
          </div>
        </div>
      )}
    </nav>
  );
}